<template>
  <ion-grid>
    <ion-row>
      <ion-col size="12" size-md="8">
        <ion-chip :color="quizItem._answer ? 'success':'secondary'">
          <ion-label>{{ quizItem.order }}</ion-label>
          <ion-icon v-if="quizItem._answer" :icon="checkmarkCircleOutline"></ion-icon>
        </ion-chip>
        <span style="font-size:medium">{{ quizItem.title }}</span>
        <ion-icon v-if="quizItem.detail || quizItem.tip" v-on:click="showToast()" style="padding-left: 3px"
                  :icon="informationCircleOutline"></ion-icon>
      </ion-col>
      <ion-col>

        <template v-if="isShowDataList()">
          <ion-select class="qualifier_select" color="dark" :multiple="multiSelect" placeholder="Select" interface="popover"
                      v-bind:class="{'completed-quiz': quizItem._answer}"
                      v-model="answer"
                      v-on:click="openDataListSelect(); $event.stopImmediatePropagation()">
            <template v-if="multiSelect">
              <ion-select-option v-for=" ans in answer" v-bind:value="ans" v-bind:key="ans.code">{{ ans.name }}</ion-select-option>
            </template>
            <template v-else>
              <ion-select-option  v-bind:value="answer" >{{ answer ? answer.name : 'Select' }}</ion-select-option>
            </template>
          </ion-select>
        </template>
        <template v-else>
          <ion-select placeholder="Select" interface="action-sheet"
                      v-bind:class="{'completed-quiz': quizItem._answer}"
                      v-bind:value="answer"
                      v-on:ionChange="selectOption($event)">
            <ion-select-option v-for=" o in options" v-bind:value="o" v-bind:key="o.code">{{ o.name }}</ion-select-option>
          </ion-select>
        </template>
      </ion-col>
    </ion-row>
    <ion-row v-if="showOtherOptionInput()">
      <ion-col>
        <ion-item>
          <ion-label v-if="quizItem.other_option_title"
                     position="floating">{{ quizItem.other_option_title }}
          </ion-label>
          <!--          <ion-input v-bind:placeholder="quizItem.other_option_placeholder"></ion-input>-->
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
</template>

<script>
import {
  IonGrid,
  IonRow,
  IonCol,
  IonChip,
  IonIcon,
  IonItem,
  IonLabel,
  IonSelect,
  IonSelectOption,
  modalController,
  isPlatform
} from '@ionic/vue';
import {
  checkmarkCircleOutline,
  informationCircleOutline
} from 'ionicons/icons';

import EoppService from "@/mixins/EoppService";
import DataListSelect from "@/components/DataListSelect";

export default {
  name: 'QuizItemSelect',
  components: {
    IonGrid,
    IonRow,
    IonCol,
    IonChip,
    // IonHeader,
    // IonToolbar,
    // IonTitle,
    // IonFooter,
    // IonButton,
    IonIcon,
    IonItem,
    IonLabel,
    // IonList,
    // IonContent,
    IonSelect,
    IonSelectOption
  },
  mixins: [EoppService],
  data() {
    return {
      checkmarkCircleOutline,
      informationCircleOutline,
      answer: null,
      options:[]
    };
  },
  mounted() {
    // console.log(this.quizItem.code, this.isShowDataList());
    if (this.isShowDataList()) {
      if (!this.quizItem.data_key) {
        this.options = this.quizItem.options;
      }
      this.initPreviousAnswer();
    } else if (this.quizItem.data_key) {
      this.loadOptions();
    } else {
      this.options = this.quizItem.options;
      this.initPreviousAnswer();
    }
  },
  props: {
    quizItem: {
      type: Object,
      required: false
    },
    multiSelect: {
      type: Boolean,
      default: false
    },
    withPreference: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    initPreviousAnswer () {
      const prev = this.getPrevQuizItem(this.quizItem.code);
      if (prev && prev._answer) {
        if ( this.isShowDataList()){
          if ( this.multiSelect ){
            this.answer = prev._answer;
          } else {
            this.options = [prev._answer];
            this.answer = prev._answer;
          }
        } else if ( this.options && this.options.length > 0 ){
          this.answer = this.options.find(o => o.code === prev._answer.code);
        } else {
          this.options = [prev._answer];
          this.answer = prev._answer;
        }
        // this.answer = prev._answer;

      }
    },
    loadOptions: function () {
      this.getData(`/data?key=${this.quizItem.data_key}`).then(res => {
        if (res && res.data) {
          // @ts-ignore
          res.data.sort((a, b) => {
            return a.name.localeCompare(b.name)
          });
          this.options = res.data;
        }
        this.initPreviousAnswer();
      })
    },
    showToast() {
      // this.messageService.toast(this.quizItem.detail, this.quizItem.tip);
    },
    selectOption(event) {
      this.answer = event.detail.value;
      this.dataChanged();
    },
    showOtherOptionInput() {
      // return this.quizItem.other_option && this.quizItem._answer &&
      //     (this.quizItem._answer.code === this.quizItem.other_option
      //         || this.quizItem._answer.id === this.quizItem.other_option)
    },
    dataChanged() {
      this.$emit('answer', this.answer);
    },
    isShowDataList() {
      return this.multiSelect || isPlatform('desktop') && this.quizItem.data_key != null;
    },
    async openDataListSelect() {

      const modal = await modalController
          .create({
            component: DataListSelect,
            cssClass: 'my-custom-class',
            componentProps: {
              dataKey: this.quizItem.data_key,
              code: null,
              multiSelect: this.multiSelect,
              withPreference: this.withPreference,
              current: this.answer ? (this.multiSelect? this.answer : [this.answer]) : [],
              items: this.options,
              showOtherOption: false
            },
          });

      modal.onDidDismiss().then(res => {
        if ( res.data ) {
          this.answer = res.data;
          // console.log(this.answer[0])
          this.dataChanged();
        }
      });

      return modal.present();
    },
  }
}
</script>
<style>
ion-select {
  max-width: 100%;
  /*background-color: #bbb;*/
  color: var(--ion-color-secondary);
  border: thin solid var(--ion-color-secondary);
  /*border: thin solid red;*/
  border-radius: 10px;
}

/*.default-select {*/
/*  color: var(--ion-color-secondary);*/
/*  border: thin solid var(--ion-color-secondary);*/
/*  border-radius: 10px;*/
/*  padding-left: 1em;*/
/*  min-width: 100%;*/
/*}*/

.completed-quiz {
  color: var(--ion-color-success);
  border: thin solid var(--ion-color-success);
  border-radius: 10px;
}

/*.completed-quiz-bg {*/
/*  background: var(--ion-color-success);*/
/*  border: thin solid var(--ion-color-success);*/
/*}*/
</style>
